import React from "react";
import { Box, Container, Typography, Button, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Hero = () => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.gradient.primary,
        color: "white",
        py: { xs: 8, md: 12 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography
              variant="h1"
              gutterBottom
              sx={{
                fontWeight: 700,
                mb: 2,
              }}
            >
              Quick Cash Loans Made Simple
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                fontWeight: 400,
                opacity: 0.9,
              }}
            >
              Get the cash you need today. Fast approval, flexible terms, and
              transparent rates.
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Button
                component={RouterLink}
                to="/apply"
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  background: "white",
                  color: (theme) => theme.palette.primary.main,
                  border: "2px solid white",
                  "&:hover": {
                    background: (theme) => theme.palette.primary.main,
                    color: "white",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(255, 255, 255, 0.1)",
                  },
                  px: 4,
                  py: 1.5,
                  fontSize: "1.1rem",
                }}
              >
                Apply Now
              </Button>
              <Button
                component={RouterLink}
                to="/contact"
                variant="outlined"
                size="large"
                sx={{
                  borderColor: "white",
                  color: "white",
                  "&:hover": {
                    borderColor: "white",
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                  },
                  px: 4,
                  py: 1.5,
                  fontSize: "1.1rem",
                }}
              >
                Contact Us
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                bgcolor: "rgba(255, 255, 255, 0.1)",
                p: 3,
                borderRadius: 2,
                backdropFilter: "blur(10px)",
              }}
            >
              <Box>
                <Typography variant="h3" sx={{ fontWeight: 700 }}>
                  R100 - R3,000
                </Typography>
                <Typography variant="body1">Loan Amount Range</Typography>
              </Box>
              <Box>
                <Typography variant="h3" sx={{ fontWeight: 700 }}>
                  Same Day
                </Typography>
                <Typography variant="body1">Quick Approval Process</Typography>
              </Box>
              <Box>
                <Typography variant="h3" sx={{ fontWeight: 700 }}>
                  1-30 Days
                </Typography>
                <Typography variant="body1">Repayment Terms</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
